import React, { useEffect } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Button,
  VStack,
  Text,
  Heading,
  Box,
  ModalCloseButton,
  Flex,
  useToast,
  Image,
} from '@chakra-ui/react';
import useModelCartao from './useModelCartao';
import Lixo from '../../../images/Excluido.svg';
import { useNavigate } from 'react-router-dom';

const DrawerExcluirCartao = (props) => {
  const disclosure = props.disclosure;
  const theme = props?.theme;
  const card = props.card;
  const { excluirCartao, loading, error, excluido } = useModelCartao({ cardId: card?.paciente_cartao_credito_pagarme_id });
  const toast = useToast();
  const navigate = useNavigate();
  useEffect(() => {
    if (excluido) {
      setTimeout(() => {
        disclosure.onClose();
        navigate(-1);
      }, 2000);
    }
  }, [excluido]);

  return (
    <>
      <Drawer isOpen={disclosure.isOpen} onClose={disclosure.onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent width="100%" h="40%" borderTopRadius={'2em'}>
          <DrawerBody p="5%">
            <ModalCloseButton _focus={false} />
            {!excluido ? (
              <>
                <Box mt={"1em"}>
                  <Flex w="100%" h="100%" justify="center" align="center">
                    <VStack spacing={4} textAlign="center">
                      <Text color="#585858" fontWeight="bold">
                        Excluir cartão
                      </Text>
                      <Text color="#585858" fontWeight="bold">
                        Tem certeza que deseja <br />
                        excluir este cartão?
                      </Text>
                    </VStack>
                  </Flex>
                </Box>
                <VStack alignItems="center" mt={'1em'}>
                  {!loading ? (
                    <>
                      <Button
                        bg={theme?.background}
                        color={theme?.fontcolor}
                        w="50%"
                        borderRadius={'0.8em'}
                        onClick={() => {
                          disclosure.onClose();
                        }}
                        mb={'1em'}
                      >
                        Não excluir cartão
                      </Button>
                      <Text
                        color={theme?.background}
                        onClick={() => {
                          if (card.default) {
                            toast({
                              title: 'Não é possível excluir este cartão',
                              description: 'Cartão principal não pode ser excluído. Para excluir este cartão remova-o como principal.',
                              status: 'error',
                              duration: 4000,
                              isClosable: true,
                              position: 'bottom',
                              colorScheme: 'red',
                              containerStyle: {
                                paddingTop: '50px',
                              },
                            });
                            return;
                          }
                          excluirCartao();
                        }}
                      >
                        Excluir cartão
                      </Text>
                    </>
                  ) : !error && loading && !excluido ? (
                    <>
                      <Button color={theme?.background} variant="outline" loading={loading} border={'none'}>
                        Carregando...
                      </Button>
                    </>
                  ) : null}
                </VStack>
              </>
            ) : (
              <>
                <Flex w="100%" h="100%" justify="center" align="center">
                  <VStack spacing={4} textAlign="center">
                    <Image src={Lixo} maxH="100px" />
                    <Text color="#585858" fontWeight="bold">
                      O cartão foi excluído <br />
                      com sucesso
                    </Text>
                  </VStack>
                </Flex>
              </>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default DrawerExcluirCartao;
